<template>
  <div class="box">
    <v-row>
      <v-col cols="12">
        <v-expansion-panels :value="panel" accordion multiple hover tile readonly>
          <v-expansion-panel :style="upperPanelHeight">
            <v-expansion-panel-header hide-actions>Role</v-expansion-panel-header>
            <v-expansion-panel-content>
              <!-- eslint-disable-next-line prettier/prettier -->
              <tree-data-table
                :headers="roleHeaders" :items="roleTree" item-key="label" :height="upperTableHeight"
                @click:row="arrangeMenuTree"
                dense hide-default-footer disable-pagination fixed-header single-select>
                <template #item.isComposite="{ value }"> {{ value == 'C' ? 'Composite' : 'Single' }} </template>
                <template #item.statusColor="{ item }">
                  <v-tooltip content-class="tooltip" bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on" :style="cssStatusColor(item.statusColor)" small>mdi-circle</v-icon>
                    </template>
                    <p>
                      <span style="font-weight:bold" small>{{ $t('rtrck.field.title.role.status') }}</span>
                    </p>
                    <span small>{{ item.statusMessage }}</span>
                  </v-tooltip>
                </template>
                <template #item.userStatusColor="{ item }">
                  <v-tooltip content-class="tooltip" bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on" :style="cssStatusColor(item.userStatusColor)" small>mdi-circle</v-icon>
                    </template>
                    <p>
                      <span style="font-weight:bold" small>{{ $t('rtrck.field.title.role.user.status') }}</span>
                    </p>
                    <span small>{{ item.userStatusMessage }}</span>
                  </v-tooltip>
                </template>
                <template #item.changeDatim="{ value }"> {{ value | format('yyyy-MM-dd') }} </template>
                <template #item.assignDatim="{ value }"> {{ value | format('yyyy-MM-dd') }} </template>
                <template #item.period="{ item }"> {{ item.fromDatim | format('yyyy-MM-dd') }} ~ {{ item.toDatim | format('yyyy-MM-dd') }} </template>
              </tree-data-table>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel :style="lowerPanelHeight">
            <v-expansion-panel-header hide-actions>Menu</v-expansion-panel-header>
            <v-expansion-panel-content>
              <!-- eslint-disable-next-line prettier/prettier -->
              <tree-data-table
                :headers="menuHeaders" :items="menuTree" item-key="label" :height="lowerTableHeight" :loading="loading"
                @click:expand="expandMenuNode"
                dense hide-default-footer disable-pagination fixed-header single-select>
              </tree-data-table>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { api } from '@/api/common/instances';
import share from './searchShare.js';
export default {
  props: {
    height: {
      type: Number,
    },
    roleTree: {
      type: Array,
    },
  },
  mixins: [share],
  data() {
    return {
      // data 'panel'은 내부의 panel 모두가 디폴트로 펼쳐져서 content가 보이게 하기 위한 조치.
      panel: [0, 1],
      menuHeaders: [
        { text: 'Description', value: 'text', width: '25%', expandable: true, sortable: false },
        { text: 'Type', value: 'reporttype', sortable: false },
        { text: 'Report', value: 'report', sortable: false },
        { text: 'Single role', value: 'sourceAgr', sortable: false },
        { text: 'Activity', value: 'flag', sortable: false },
      ],
      menuTree: [],
      loading: false,
    };
  },
  methods: {
    async arrangeMenuTree(roleNode, { select, selected }) {
      select(!selected);
      let param = {};
      param.svrYmdhms = roleNode.svrYmdhms;
      param.sstmId = roleNode.sstmId;
      param.mandt = roleNode.mandt;
      param.agrName = roleNode.agrName;
      param.objectId = '00000001';
      this.menuTree = await this.getRoleHierTree(param);
    },
    async expandMenuNode(node, { add }) {
      if (node._opened) return;
      let roleHierTree = await this.getRoleHierTree(node);
      // 현재 tree는 expand 시 추가되는 자식은 순서를 거꾸로 해주어야 한다.2021.01.11.KWShin.
      roleHierTree = roleHierTree.reverse();
      add(roleHierTree);
    },
    async getRoleHierTree(node) {
      this.loading = true;
      const { data } = await api.get('/rtrck/search/role-hier', {
        params: {
          svrYmdhms: node.svrYmdhms,
          sstmId: node.sstmId,
          mandt: node.mandt,
          agrName: node.agrName,
          parentId: node.objectId,
        },
      });
      // RoleHierarchy는 folder 속성이 'X'이면 자식 노드를 갖는다.
      data.forEach(elm => {
        elm.children = [];
        if (elm.folder == 'X') elm.leaf = false;
        else elm.leaf = true;
      });
      // console.log('in RoleMenu getRoleHierTree()... data=', data);
      this.loading = false;
      return data;
    },
  },
};
</script>

<style lang="scss" scoped>
.v-expansion-panel-content ::v-deep .v-expansion-panel-content__wrap {
  padding: 0;
}
</style>
